import { render, staticRenderFns } from "./ZonaCard.vue?vue&type=template&id=798fa9e6&scoped=true&"
import script from "./ZonaCard.vue?vue&type=script&lang=js&"
export * from "./ZonaCard.vue?vue&type=script&lang=js&"
import style0 from "./ZonaCard.vue?vue&type=style&index=0&id=798fa9e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798fa9e6",
  null
  
)

export default component.exports